import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import useCustomStyle from '../../hooks';
import HomepageAsset from 'public/screens/Home/Components/Asset';
import Link from '../Link';
import { ContentfulRichText } from 'common/components';

import './banner.less';
import { getStylesByPrefix, toStyleObject } from '../../utils';

export default function Banner({ component, refs, handleTrack }) {
  const classNames = useClassName('clp-banner');
  const [setRef, style] = useCustomStyle(component.fields.settings);

  const background = component.fields.background;
  const title = component.fields.title;
  const content = component.fields.content;
  const cta = component.fields.cta;

  const containerStyle = toStyleObject(
    getStylesByPrefix('--container-', style)
  );
  const contentStyle = toStyleObject(getStylesByPrefix('--content-', style));
  const titleStyle = toStyleObject(getStylesByPrefix('--title-', style));
  const descriptionStyle = toStyleObject(
    getStylesByPrefix('--description-', style)
  );
  const mainImageStyle = toStyleObject(
    getStylesByPrefix('--main-image-', style)
  );
  const ctaStyle = toStyleObject(getStylesByPrefix('--cta-', style));
  const backgroundStyle = toStyleObject(
    getStylesByPrefix('--background-', style)
  );

  return (
    <div ref={setRef} className={classNames('container')}>
      <div className={classNames('inner')} style={containerStyle}>
        {background && (
          <div className={classNames('background')} style={backgroundStyle}>
            <HomepageAsset
              asset={background}
              className={classNames('background-asset')}
            />
          </div>
        )}
        <div className={classNames('content')} style={contentStyle}>
          {title && (
            <h2 className={classNames('title')} style={titleStyle}>
              {title}
            </h2>
          )}
          {content && (
            <div className={classNames('text')}>
              <ContentfulRichText
                field={{ 'en-US': content }}
                style={descriptionStyle}
              />
            </div>
          )}
          {cta && (
            <Link
              className={classNames('cta')}
              component={cta}
              refs={refs}
              handleTrack={handleTrack}
              style={ctaStyle}
            />
          )}
        </div>
        {component.fields.mainImage && (
          <HomepageAsset
            asset={component.fields.mainImage}
            className={classNames('main-image')}
            style={mainImageStyle}
          />
        )}
      </div>
    </div>
  );
}

Banner.propTypes = {
  component: PropTypes.object.isRequired,
  refs: PropTypes.object,
  handleTrack: PropTypes.func,
};

Banner.defaultProps = {
  refs: {},
  handleTrack: () => {},
};
